export const LOCALSTORAGE_KEYS = {
    subscriptionId: 'via:sid',
    appId: 'via:aid',
    accountId: 'via:aaid'
};
